/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiAvv, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of AvvController.
 */
export class AvvRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /avv:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiAvv>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiAvv>>, ListRequest>('/avv:query', listRequest, query);
    }

    /**
     * Calls GET /avv:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiAvv>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiAvv>>>('/avv:query', query);
    }

    /**
     * Calls GET /avv/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiAvv>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiAvv>>(`/avv/${primaryId}`, query);
    }

    /**
     * Calls POST /avv:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiAvv>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiAvv>>, ListRequestWithIds>('/avv:batch', listRequest, query);
    }

    /**
     * Calls POST /avv:prefill
     */
    public createPrefilled(): Promise<Result<ApiAvv>> {
        return this.http.post<Result<ApiAvv>, undefined>('/avv:prefill', undefined);
    }

    /**
     * Calls POST /avv/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiAvv>>> {
        return this.http.post<Result<LockedContextDto<ApiAvv>>, undefined>(`/avv/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /avv/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiAvv>> {
        return this.http.post<Result<ApiAvv>, undefined>(`/avv/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /avv/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiAvv[]>> {
        return this.http.post<Result<ApiAvv[]>, string[]>('/avv/locks', ids);
    }

    /**
     * Calls POST /avv/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/avv/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /avv/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/avv/${primaryId}/locks`);
    }

    /**
     * Calls POST /avv
     */
    public add(dto: ApiAvv): Promise<Result<ApiAvv>> {
        return this.http.post<Result<ApiAvv>, ApiAvv>('/avv', dto);
    }

    /**
     * Calls PUT /avv/{primaryId}
     */
    public update(dto: ApiAvv, primaryId: string): Promise<Result<ApiAvv>> {
        return this.http.put<Result<ApiAvv>, ApiAvv>(`/avv/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /avv
     */
    public putRange(dtos: ApiAvv[]): Promise<Result<ApiAvv[]>> {
        return this.http.patch<Result<ApiAvv[]>, ApiAvv[]>('/avv', dtos);
    }

    /**
     * Calls DELETE /avv/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/avv/${primaryId}`);
    }
}
